<mat-form-field [formGroup]="dateField" class="wideInput" appearance="outline"
  [ngClass]="{ 'error-border': dateField.get('date')?.invalid && (dateField.get('date')?.touched || dateField.get('date')?.dirty) }">

  <mat-label [ngClass]="{ 'error-text': dateField.get('date')?.invalid && (dateField.get('date')?.touched || dateField.get('date')?.dirty) }">
    {{ label }}
  </mat-label>

  <input matInput #dateInput [matDatepicker]="dp" formControlName="date" 
    [attr.aria-label]="label" placeholder="(mm/yyyy)"
    [max]="maxOneYearFromNow" [min]="earliestQueriedReportDate" 
    (input)="handleDateChange(dateInput.value)"> 

  <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>

  <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)"></mat-datepicker>

  <mat-error *ngIf="dateField.get('date')?.hasError('required') && (dateField.get('date')?.touched || dateField.get('date')?.dirty)">
    {{ label }} is required
  </mat-error>
  <mat-error *ngIf="dateField.get('date')?.hasError('invalidDate') && (dateField.get('date')?.touched || dateField.get('date')?.dirty)">
    Invalid date
  </mat-error>

  <mat-hint *ngIf="customErrorMessage" [ngClass]="{ 'error-text': customErrorMessage }">
    {{ customErrorMessage }}
  </mat-hint>

</mat-form-field>
